import React, {FC} from 'react'
import md5 from 'md5'
import {useIntl} from 'react-intl'
import {roleColor} from '@/components/utils/colors'
import {Link} from 'react-router-dom'

type Props = {
  avatar?: {
    type: string
    hash?: string
  }
  displayName: string
  email: string
  role?:string
  to: string
}

const IdentityCell: FC<Props> = ({email, displayName, avatar, role, to}) => {
  const intl = useIntl()
  return (
    <div className='d-flex align-items-center'>
      {/* begin:: Avatar */}
      <div className='symbol symbol-circle symbol-50px overflow-hidden me-3'>
        <span>
          <div className='symbol-label'>
            {avatar?.hash !== undefined ? (
              <img src={`https://www.gravatar.com/avatar/${avatar.hash}?d=${avatar.type}`} alt={displayName} className='w-100' />
            ): (
              <img src={`https://www.gravatar.com/avatar/${md5(email)}?d=${avatar?.type ?? 'identicon'}`} alt={displayName} className='w-100' />
            )}
          </div>
        </span>
      </div>
      <Link className='d-flex flex-column text-muted text-hover-primary' to={to}>
        <span className='text-gray-800 mb-1'>
          {displayName}
          {role !== undefined && (<span className={`badge badge-light-${roleColor(role)} ms-2`}>
            {intl.formatMessage({id: role})}
          </span>)}
        </span>
        <span>{email}</span>
      </Link>
    </div>
  )
}

export {IdentityCell}
